import { useEffect, useState } from "react"
import api from "../api-client"
import { Section } from "../components"
import { Spinner, SpinnerSize } from "@fluentui/react"
import { dollars, LoanApplication, mmddyyyy } from "@oneethos/shared"
import { Link } from "react-router-dom"
import { useAppState } from "../hooks"

const getApplyUrl = (
  item: LoanApplication,
  referralUrlCommercial: string
): string => {
  if (item.projectType === 'residential') return `/apply/${item.lookup}`

  const url = new URL(referralUrlCommercial ?? '/apply', window.location.origin)
  url.pathname = url.pathname.replace(/\/$/, '')
  url.searchParams.set('a', item.loanAmount.toFixed(2))
  url.searchParams.set('i', item.installerID)
  url.searchParams.set('r', item.lookup)
  if (item.avgMonthlyUtilityBill != null) {
    url.searchParams.set('b', item.avgMonthlyUtilityBill.toFixed(2))
  }
  if (item.estAvgMonthlyUtilityBillAfterSolar != null) {
    url.searchParams.set('af', item.estAvgMonthlyUtilityBillAfterSolar.toFixed(2))
  }
  return url.origin === window.location.origin
    ? `${url.pathname}${url.search}${url.hash}`
    : url.toString()
}

export const ApplicationsPage = () => {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const { tenant: { config: tenantConfig } } = useAppState()

  useEffect(() => {
    api.get('/c/loanapps/list').then((res: LoanApplication[]) => {
      setList(res)
    }).catch(ex => setError(ex.error || JSON.stringify(ex)))
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <Section>
        <Spinner size={SpinnerSize.large} />
      </Section>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        {error}
      </div>
    )
  }

  return (
    <div className="consumer-applications-page">
      <Section>
        <h4>My Loan Applications</h4>
        <ul className="list-group">
          {list.map((item: LoanApplication) => {
            const applyUrl = getApplyUrl(item, tenantConfig?.referralUrlCommercial)
            const isExternalApplyUrl = /^https?:\/\//i.test(applyUrl)
            return (
              <li key={item._id} className="list-group-item lapp">
                <div>
                  <div><b>Amount:</b> {dollars(item.loanAmount)}</div>
                  <div><b>Address:</b> {item.userAddress?.streetAddress ?? 'N/A'}</div>
                  <div><b>Step:</b> {item.preSubmitStatus}</div>
                  <div><b>Created Date:</b> {mmddyyyy(new Date(item.createdDate))}</div>
                  <div className="text-capitalize"><b>Pre-Qualification:</b> {item.prequalResultCombined || item.prequalResult}</div>
                </div>
                {item.preSubmitStatus !== 'Submitted' ? <div>
                  {isExternalApplyUrl ? (
                    <a 
                      className="btn btn-primary btn-sm" 
                      rel="noopener noreferrer" 
                      target="_blank" 
                      href={applyUrl}
                    >
                      Resume Application
                    </a>
                  ) : (
                    <Link className="btn btn-primary btn-sm" to={applyUrl}>Resume Application</Link>
                  )}
                </div> : null}
              </li>)
          })}
        </ul>
      </Section>
    </div>
  )
}

export default ApplicationsPage